import { ResponsivePie } from '@nivo/pie'
import { ResponsiveRadialBar } from '@nivo/radial-bar'


import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import React,{useState, useEffect} from 'react';

import FormGroup from '@mui/material/FormGroup';

//auswahl mit mui
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';



import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';

function App() {

  const [stateVars, setStateVars] = useState({
    spouse: false,
    partner: false,
    children: false,
    mother: false,
    siblings: false,
    other: false,
    chooseLaw: 'lawFrom23'
  });


  const [chartData, setChartData] = useState([{}]);
  const [obligatoryPartsTil23, setObligatoryPartsTil23] = useState({});
  const [obligatoryPartsFrom23, setObligatoryPartsFrom23] = useState({});

  useEffect(() => {
    const Calc = () => {
      let inheritation = {}; //speichert die erbfolge


      if(stateVars.spouse === true) {
        if(stateVars.children === true) { //erstes Parentel
          inheritation = {
            spouse: 0.5,
            children: 0.5
          };
        } else if(stateVars.siblings === true || stateVars.mother === true || stateVars.father === true) { //zweites Parentel
          inheritation = {
            spouse: 0.75
          }

          if(stateVars.mother === true && stateVars.father === true) {
            inheritation.mother = 0.125;
            inheritation.father = 0.125;
          } else {
            let countSecondParentelMembers = [stateVars.siblings, stateVars.mother, stateVars.father].filter(Boolean).length;

            if(stateVars.siblings === true) {
              inheritation.siblings = 1 / countSecondParentelMembers * 0.25;
            }
  
            if(stateVars.mother === true) {
              inheritation.mother = 1 / countSecondParentelMembers * 0.25;
            }
  
            if(stateVars.father === true) {
              inheritation.father = 1/countSecondParentelMembers * 0.25;
            }  
          }

        } else if(stateVars.other === true) { //drittes Parentel
          inheritation = { spouse: 1 };
        } else {
          inheritation = { spouse: 1 };
        }

      } else {
        if(stateVars.children === true) { //erstes Parentel
          inheritation = { children: 1 };
        } else if(stateVars.siblings === true || stateVars.mother === true || stateVars.father === true) { //zweites Parentel
          inheritation = { };

          if(stateVars.mother === true && stateVars.father === true) {
            inheritation.mother = 0.5;
            inheritation.father = 0.5;
          } else {
            let countSecondParentelMembers = [stateVars.siblings, stateVars.mother, stateVars.father].filter(Boolean).length;

            if(stateVars.siblings === true) {
              inheritation.siblings = 1 / countSecondParentelMembers;
            }
  
            if(stateVars.mother === true) {
              inheritation.mother = 1 / countSecondParentelMembers;
            }
  
            if(stateVars.father === true) {
              inheritation.father = 1/countSecondParentelMembers;
            }  
          }

        } else if(stateVars.other === true) { //drittes Parentel
          inheritation = { other: 1 };
        } else {
          inheritation = { state: 1 };
        }
      }

      let inheritationOrder = [
        { id: 'Ehepartner', label: 'Ehepartner', value: inheritation.spouse || 0 * 100, color: '#0088FE', state: stateVars.spouse },
        { id: 'Partner', label: 'Konkubinatspartner/in (nichteheliche Lebensgemeinschaft)', value: 0, color: 'rgb(189, 127, 128)', state: stateVars.partner },
        { id: 'Kinder',label: 'Kinder', value: inheritation.children || 0 * 100, color: '#00C49F', state: stateVars.children},
        { id: 'Mutter',label: 'Mutter', value: inheritation.mother || 0 * 100, color: '#FFBB28', state: stateVars.mother},
        { id: 'Vater',label: 'Vater', value: inheritation.father|| 0  * 100, color: '#FF8042', state: stateVars.father},
        { id: 'Geschwister / ­Neffen / ­Nichten und deren Nach­kommen',label: 'Geschwister / ­Neffen / ­Nichten und deren Nach­kommen', value: inheritation.siblings || 0 * 100, color: 'rgb(189, 213, 128)', state: stateVars.siblings},
        { id: 'Sonstige Verwandte',label: 'Sonstige Verwandte (Gross­eltern, Onkel, Tanten, Cousins, Cousinen und deren Nachkommen)', value: inheritation.other || 0 * 100, color: 'rgb(171,219,227)', state: stateVars.other},
        { id: 'Staat',label: 'Staat', value: inheritation.state || 0 * 100, color: '#00C49F'}
      ].filter(item => (item.state === true || item.value > 0));

      setChartData(inheritationOrder);

      let alphaTil23 = (stateVars.chooseLaw === 'lawTil23' ? 1 : 0.2);
      let CalcObligatoryPartsTil23 = {
        'id': "bis 2023",
        'data': [
          { x: 'Ehepartner', y: inheritation.spouse * 0.5 || 0 * 100, color: 'rgb(0, 136, 254,' + alphaTil23 + ')', state: stateVars.spouse},
          { x: 'Konkubinatspartner/in (nichteheliche Lebensgemeinschaft)', y: 0, color: 'rgb(189, 127, 128,' + alphaTil23 + ')', state: stateVars.partner},
          { x: 'Kinder',y: inheritation.children * 0.75 || 0 * 100, color: 'rgb(0, 196, 159,' + alphaTil23 + ')', state: stateVars.children},
          { x: 'Mutter',y: inheritation.mother  * 0.5 || 0 * 100, color: 'rgb(255, 187, 40, ' + alphaTil23 + ')', state: stateVars.mother},
          { x: 'Vater',y: inheritation.father  * 0.5 || 0  * 100, color: 'rgb(255, 128, 66,' + alphaTil23 + ')', state: stateVars.father},
          { x: 'Geschwister / ­Neffen / ­Nichten und deren Nach­kommen',y: inheritation.siblings * 0 || 0 * 100, color: 'rgb(189, 213, 128,' + alphaTil23 + ')', state: stateVars.siblings},
          { x: 'Sonstige Verwandte',y: inheritation.other * 0 || 0 * 100, color: 'rgb(171,219,227,' + alphaTil23 + ')', state: stateVars.other}
        ].filter(item => (item.state === true || item.y > 0))
      };

      CalcObligatoryPartsTil23.data = [...CalcObligatoryPartsTil23.data, {
          x: 'Freie Quote',
          y: 1 - CalcObligatoryPartsTil23.data.reduce((accumulator, item) => {
            return accumulator + item.y;
          }, 0),
        }
      ];

      let alphaFrom23 = (stateVars.chooseLaw === 'lawFrom23' ? 1 : 0.2);
      let CalcObligatoryPartsFrom23 = {
        'id': "ab 2023",
        'data': [
          { x: 'Ehepartner', y: inheritation.spouse * 0.5 || 0 * 100, color: 'rgb(0, 136, 254,' + alphaFrom23 + ')' , state: stateVars.spouse},
          { x: 'Konkubinatspartner/in (nichteheliche Lebensgemeinschaft)', y: 0, color: 'rgb(189, 127, 128,' + alphaFrom23 + ')', state: stateVars.partner},
          { x: 'Kinder',y: inheritation.children * 0.5 || 0 * 100, color: 'rgb(0, 196, 159,' + alphaFrom23 + ')' , state: stateVars.children},
          { x: 'Mutter',y: inheritation.mother  * 0 || 0 * 100, color: 'rgb(255, 187, 40, ' + alphaFrom23 + ')', state: stateVars.mother},
          { x: 'Vater',y: inheritation.father  * 0 || 0  * 100, color: 'rgb(255, 128, 66,' + alphaFrom23 + ')', state: stateVars.father},
          { x: 'Geschwister / ­Neffen / ­Nichten und deren Nach­kommen',y: inheritation.siblings * 0 || 0 * 100, color: 'rgb(189, 213, 128,' + alphaFrom23 + ')' , state: stateVars.siblings},
          { x: 'Sonstige Verwandte',y: inheritation.other * 0 || 0 * 100, color: 'rgb(171,219,227,' + alphaFrom23 + ')', state: stateVars.other}
        ].filter(item => (item.state === true || item.y > 0))
      }

      CalcObligatoryPartsFrom23.data = [...CalcObligatoryPartsFrom23.data, {
        x: 'Freie Quote',
        y: 1 - CalcObligatoryPartsFrom23.data.reduce((accumulator, item) => {
          return accumulator + item.y;
        }, 0),
      }
    ];

    setObligatoryPartsTil23(CalcObligatoryPartsTil23);
    setObligatoryPartsFrom23(CalcObligatoryPartsFrom23);

    }
    
    Calc();
  }, [stateVars]);   

  const changeLaw = (event, newAlignment) => {
    if(newAlignment === 'lawTil23' || newAlignment === 'lawFrom23') {
      setStateVars({ ...stateVars, chooseLaw: newAlignment });
    }
  };

  return (
    <div className="App">
      <h2 id="Hinterlassene_Personen_auswaehlen">Hinterlassene Personen auswählen</h2>
      <Box sx={{ minWidth: 120 }} className="erbrechner-auswahl">
        {/* <div className="checkbox-wrapper">
            <input id="checkspouse" onChange={() => setStateVars({ ...stateVars, spouse: !stateVars.spouse })} type="checkbox" />
            <label for="checkspouse">Ehepartner/in oder einge­tragene/r Lebenspartner/in</label>
        </div>
        <div className="checkbox-wrapper">
            <input id="checkpartner" onChange={() => setStateVars({ ...stateVars, partner: !stateVars.partner })} type="checkbox" />
            <label for="checkpartner">Konkubinatspartner/in (nichteheliche Lebensgemeinschaft)</label>
        </div>
        <div className="checkbox-wrapper">
            <input id="checkchildren" onChange={() => setStateVars({ ...stateVars, children: !stateVars.children })} type="checkbox" />
            <label for="checkchildren">Kinder/­Enkel und deren Nachkommen</label>
        </div>
        <div className="checkbox-wrapper">
            <input id="checkmother" onChange={() => setStateVars({ ...stateVars, mother: !stateVars.mother })} type="checkbox" />
            <label for="checkmother">Mutter</label>
        </div>
        <div className="checkbox-wrapper">
            <input id="checkfather" onChange={() => setStateVars({ ...stateVars, father: !stateVars.father })} type="checkbox" />
            <label for="checkfather">Vater</label>
        </div>
        <div className="checkbox-wrapper">
            <input id="checksiblings" onChange={() => setStateVars({ ...stateVars, siblings: !stateVars.siblings })} type="checkbox" />
            <label for="checksiblings">Geschwister / ­Neffen / ­Nichten und deren Nach­kommen</label>
        </div>
        <div className="checkbox-wrapper">
            <input id="checkother" onChange={() => setStateVars({ ...stateVars, other: !stateVars.other })} type="checkbox" />
            <label for="checkother">Sonstige Verwandte (Gross­eltern, Onkel, Tanten, Cousins, Cousinen und deren Nachkommen)</label>
        </div> */}


        <FormGroup>
          <FormControlLabel onChange={({ }) => setStateVars({ ...stateVars, spouse: !stateVars.spouse })} control={<Checkbox />} label="Ehepartner/in oder einge­tragene/r Lebenspartner/in" />
          <FormControlLabel onChange={({ }) => setStateVars({ ...stateVars, partner: !stateVars.partner })} control={<Checkbox />} label="Konkubinatspartner/in (nichteheliche Lebensgemeinschaft)" />
          <FormControlLabel onChange={({ }) => setStateVars({ ...stateVars, children: !stateVars.children })} control={<Checkbox />} label="Kinder/­Enkel und deren Nachkommen" />
          <FormControlLabel onChange={({ }) => setStateVars({ ...stateVars, mother: !stateVars.mother })} control={<Checkbox />} label="Mutter" />
          <FormControlLabel onChange={({ }) => setStateVars({ ...stateVars, father: !stateVars.father })} control={<Checkbox />} label="Vater" />
          <FormControlLabel onChange={({ }) => setStateVars({ ...stateVars, siblings: !stateVars.siblings })} control={<Checkbox />} label="Geschwister / ­Neffen / ­Nichten und deren Nach­kommen" />
          <FormControlLabel onChange={({ }) => setStateVars({ ...stateVars, other: !stateVars.other })} control={<Checkbox />} label="Sonstige Verwandte (Gross­eltern, Onkel, Tanten, Cousins, Cousinen und deren Nachkommen)" />
        </FormGroup>

      </Box>
      <div className='erbrechnerSpacer'></div>
      <h2 id="Erbfolge">Erbfolge</h2>
      <div className='erbrechnerSpacer'></div>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={7} lg={7} xl={7}>
          <div className='chartwrapper'>
            <ResponsivePie
              data={chartData.filter(item => item.value > 0)}
              valueFormat=">-.2%"
              margin={{ top: 40, right: 40, bottom: 40, left: 40 }}
              innerRadius={0.5}
              padAngle={0.7}
              cornerRadius={3}
              activeOuterRadiusOffset={8}
              borderWidth={1}
              borderColor={{ from: 'color', modifiers: [ [ 'darker', 0.2 ] ] }}
              enableArcLinkLabels={false}
              arcLinkLabelsColor={{ from: 'color' }}
              colors={{ datum: 'data.color' }}
            />
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
          <table className='inheritationcalcResultTable'>
            {chartData.map(person => {
                return (
                <tr>
                  <td style={{verticalAlign: 'top'}}><div className='coloredTableBox' style={{backgroundColor: person.color}}></div></td>
                  <td><b>{(person.value * 100).toFixed(2)}%</b> {person.label}</td>
                </tr>
                );
              })}
          </table>

        </Grid>
      </Grid>
   
    <h2 id="Pflichtteil_und_freie_Quote">Pflichtteil und freie Quote</h2>
      <FormGroup>
            <ToggleButtonGroup
              color="primary"
              exclusive
              aria-label="Platform"
              value={stateVars.chooseLaw}
              onChange={changeLaw}
            >
              <ToggleButton value="lawTil23">Erbrecht bis 2023 hervorheben</ToggleButton>
              <ToggleButton value="lawFrom23">Erbrecht seit 2023 hervorheben</ToggleButton>
            </ToggleButtonGroup>
          </FormGroup>
    <Grid container spacing={2}>
    <Grid item xs={12} sm={12} md={7} lg={7} xl={7}>
          <div className='chartwrapper'>
            <ResponsiveRadialBar
                data={[
                  stateVars.chooseLaw === 'lawTil23' ? obligatoryPartsFrom23 : obligatoryPartsTil23,
                  stateVars.chooseLaw === 'lawFrom23' ? obligatoryPartsFrom23 : obligatoryPartsTil23,
                ]}
                enableRadialGrid={false}
                enableCircularGrid={false}
                enableLabels={true}
                endAngle={360}
                valueFormat=">-.2%"
                padding={0.2}
                padAngle={0.7}
                enableTracks={false}
                cornerRadius={3}
                margin={{ top: 40, right: 40, bottom: 40, left: 40 }}
                radialAxisStart={null}
                circularAxisOuter={null}
                colors={{ datum: 'data.color' }}
                defs={[
                  {
                  "id": "custom",
                  "type": "patternLines",
                  "spacing": 5,
                  "rotation": -60,
                  "lineWidth": 4,
                  "background": "#95f4b6",
                  "color": "#83d77e"
                },
              ]}
              fill={[
                // match using query object
                // (can be used with http rendering API
                { match: { x: 'Freie Quote' }, id: 'custom' }
            ]}
    
  

              />
          </div>
          </Grid>
          <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
          <h3 id="Ab_2023">Seit 2023</h3>
          <table>
          {obligatoryPartsFrom23.data && obligatoryPartsFrom23.data.map(person => {
              return (
              <tr>
                <td style={{verticalAlign: 'top'}}>
                  {(() => {
                    if (person.x === 'Freie Quote' && stateVars.chooseLaw === 'lawTil23') {
                      return (
                        <div className='coloredTableBox coloredTableBoxFreieQuote coloredTableBoxFreieQuote-alpha'></div>
                      )
                    } else if (person.x === 'Freie Quote' && stateVars.chooseLaw === 'lawFrom23') {
                      return (
                        <div className='coloredTableBox coloredTableBoxFreieQuote'></div>
                      )
                    } else {
                      return (
                        <div className='coloredTableBox' style={{backgroundColor: person.color}}></div>
                      )
                    }
                  })()}

                </td>
                <td><b>{(person.y * 100).toFixed(2)}%</b> {person.x}</td>
              </tr>
              );
            })}
          </table>
          <div className='erbrechnerSpacer'></div>
          <h3 id="Bis_2023">Bis 2023</h3>
          <table className='inheritationcalcResultTable'>
          {obligatoryPartsTil23.data && obligatoryPartsTil23.data.map(person => {
              return (
              <tr>
                <td style={{verticalAlign: 'top'}}>
                {(() => {
                    if (person.x === 'Freie Quote' && stateVars.chooseLaw === 'lawFrom23') {
                      return (
                        <div className='coloredTableBox coloredTableBoxFreieQuote coloredTableBoxFreieQuote-alpha'></div>
                      )
                    } else if (person.x === 'Freie Quote' && stateVars.chooseLaw === 'lawTil23') {
                      return (
                        <div className='coloredTableBox coloredTableBoxFreieQuote'></div>
                      )
                    } else {
                      return (
                        <div className='coloredTableBox' style={{backgroundColor: person.color}}></div>
                      )
                    }
                  })()}
                </td>
                <td><b>{(person.y * 100).toFixed(2)}%</b> {person.x}</td>
              </tr>
              );
            })}
          </table>
        </Grid>
      </Grid>

  </div>
  );

}

export default App;

